export default "__VITE_ASSET__9u5fwYqy__"